import { GlobalErrorFallback } from "@dust-tt/front/components/error_boundary/GlobalErrorFallback";
// errorElement du routeur : React Router attrape l'erreur de rendu d'une route avant
// l'ErrorBoundary, elle ne serait donc jamais remontee. On la signale ici (sans rapporteur pose,
// rapporterErreur ne fait rien) puis on rend l'ecran d'erreur habituel. Une reponse de route
// (404, redirection jetee par un loader) n'est pas une exception : elle n'est pas remontee.
import { rapporterErreur } from "@dust-tt/front/lib/compta/erreurs_sentry";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export function RapportErreurDeRoute() {
  const erreur = useRouteError();

  useEffect(() => {
    if (erreur && !isRouteErrorResponse(erreur)) {
      rapporterErreur(erreur, { origine: "route" });
    }
  }, [erreur]);

  return <GlobalErrorFallback />;
}
